import React, { useEffect,  useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourDropDownFIlter from "../../../../components/FilterBox/ColourFilter/ColourDropDownFIlter";
import { format } from "date-fns";



import ColourTable from "../../../../components/Tables/ColourTable";
import {
  ColourFilter,
  ItemVsSupplier,
  ItemVsSupplierFun,
  MonthlyStock,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import ColourParentChild from "../../../../components/Tables/ColourParentChild";
import { useRef } from "react";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import { Loader } from "../../../../components/Loader/Loader";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";

export const Item_supplierAnalysis = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, MonthlyStockdata, ItemVsSupplierdata } =
    useSelector((state) => state.InwardAnylysisSlice);

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  const [activeTable, setActiveTable] = useState("ITEMWISE");

  const [showFilter, setShowFilter] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [selectedItemName, setSelectedItemName] = useState([]);
  const [selectedItemGroup, setSelectedItemGroup] = useState([]);
  const [selectedItemSubGroup, setSelectedItemSubGroup] = useState([]);

  const [itemNameSearch, setItemNameSearch] = useState("");
  const [itemGroupSearch, setItemGroupSearch] = useState("");
  const [itemSubGroupSearch, setItemSubGroupSearch] = useState("");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }
  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };
  const itemNameList =
    ColourfilterData?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  const itemGroupList =
    ColourfilterData?.ItemGroup?.map((item) => ({
      label: item.ItemGroupName,
      value: item.ItemGroupID,
    })) || [];

  const itemSubGroupList =
    ColourfilterData?.ItemSGroup?.map((item) => ({
      label: item.ItemSubGroupName,
      value: item.ItemSubGroupID,
    })) || [];

  const [filters, setFilters] = useState({
    group: [],
    itemName: [],
    itemGroup: [],
    itemSubGroup: [],
  });

  const [search, setSearch] = useState({
    group: "",
    itemName: "",
    itemGroup: "",
    itemSubGroup: "",
  });

  useEffect(() => {
    if (!startDate || !endDate) return;

    dispatch(ColourFilter());


    dispatch(
      ItemVsSupplier({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ItemGroupIDs: filters.itemGroup.join(","),
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [dispatch, Firm, FinancialYear, startDate, endDate]);

  const toggleItem = (field, item) => {
    setFilters((prev) => ({
      ...prev,
      [field]: prev[field]?.includes(item.value)
        ? prev[field].filter((i) => i !== item.value)
        : [...(prev[field] || []), item.value],
    }));
  };

  const selectAll = (field, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [field]:
        prev[field]?.length === items.length
          ? []
          : allIds,
    }));
  };

  const handleSearch = (field, value) => {
    setSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const TableChartColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Qty", key: "TotalInwQty", align: "right", format: "true" },
    { label: "Apr", key: "AprilQty", align: "right", format: "true" },
    { label: "May", key: "MayQty", align: "right", format: "true" },
    { label: "Jun", key: "JunQty", align: "right", format: "true" },
    { label: "Jul", key: "JulyQty", align: "right", format: "true" },
    { label: "Aug", key: "AugQty", align: "right", format: "true" },
    { label: "Sep", key: "SepQty", align: "right", format: "true" },
    { label: "Oct", key: "OctQty", align: "right", format: "true" },
    { label: "Nov", key: "NovQty", align: "right", format: "true" },
    { label: "Dec", key: "DecQty", align: "right", format: "true" },
    { label: "Jan", key: "JanQty", align: "right", format: "true" },
    { label: "Feb", key: "FebQty", align: "right", format: "true" },
    { label: "Mar", key: "MarchQty", align: "right", format: "true" },
  ];

  const TableChartRow = (ItemVsSupplierdata?.ItemWise || []).map((row) => ({
    ItemName: row?.itemname ?? "",
    AprilQty: row?.AprilQty ?? 0,
    MayQty: row?.MayQty ?? 0,
    JunQty: row?.JunQty ?? 0,
    JulyQty: row?.JulyQty ?? 0,
    AugQty: row?.AugQty ?? 0,
    SepQty: row?.SepQty ?? 0,
    OctQty: row?.OctQty ?? 0,
    NovQty: row?.NovQty ?? 0,
    DecQty: row?.DecQty ?? 0,
    JanQty: row?.JanQty ?? 0,
    FebQty: row?.FebQty ?? 0,
    MarchQty: row?.MarchQty ?? 0,
    TotalInwQty: row?.TotalInwQty ?? 0,
  }));

  const TableChartColumns1 = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Party Name",
      key: "PartyName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Qty", key: "TotalInwQty", align: "right", format: "true" },
    { label: "Apr", key: "AprilQty", align: "right", format: "true" },
    { label: "May", key: "MayQty", align: "right", format: "true" },
    { label: "Jun", key: "JunQty", align: "right", format: "true" },
    { label: "Jul", key: "JulyQty", align: "right", format: "true" },
    { label: "Aug", key: "AugQty", align: "right", format: "true" },
    { label: "Sep", key: "SepQty", align: "right", format: "true" },
    { label: "Oct", key: "OctQty", align: "right", format: "true" },
    { label: "Nov", key: "NovQty", align: "right", format: "true" },
    { label: "Dec", key: "DecQty", align: "right", format: "true" },
    { label: "Jan", key: "JanQty", align: "right", format: "true" },
    { label: "Feb", key: "FebQty", align: "right", format: "true" },
    { label: "Mar", key: "MarchQty", align: "right", format: "true" },
  ];

  const TableChartRow1 = (ItemVsSupplierdata?.PartyWise || []).map((row) => ({
    PartyName: row?.AcName ?? "",
    AprilQty: row?.AprilQty ?? 0,
    MayQty: row?.MayQty ?? 0,
    JunQty: row?.JunQty ?? 0,
    JulyQty: row?.JulyQty ?? 0,
    AugQty: row?.AugQty ?? 0,
    SepQty: row?.SepQty ?? 0,
    OctQty: row?.OctQty ?? 0,
    NovQty: row?.NovQty ?? 0,
    DecQty: row?.DecQty ?? 0,
    JanQty: row?.JanQty ?? 0,
    FebQty: row?.FebQty ?? 0,
    MarchQty: row?.MarchQty ?? 0,
    TotalInwQty: row?.TotalInwQty ?? 0,
  }));

  // --- Table Configuration ---
  const columns = [
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Min Rate", key: "MinInwRate", align: "right", format: "true" },
    { label: "Max Rate", key: "MaxInwRate", align: "right", format: "true" },
    {
      label: "Different Rate",
      key: "DiffRate",
      align: "right",
      format: "true",
    },
    {
      label: "Consumption",
      key: "ConsumptionQty",
      align: "right",
      format: "true",
    },
    { label: "Stock", key: "ClosingStockQty", align: "right", format: "true" },
  ];

  const rows = (ItemVsSupplierdata?.MinMaxRate || []).map((row) => ({
    AcName: row?.AcName ?? "",
    MonthName: row?.MonthName ?? "",
    MinInwRate: row?.MinInwRate ?? 0,
    MaxInwRate: row?.MaxInwRate ?? 0,
    DiffRate: row?.DiffRate ?? 0,
    ConsumptionQty: row?.ConsumptionQty ?? 0,
    ClosingStockQty: row?.ClosingStockQty ?? 0,
  }));

  const handleSubmit1 = () => {

    dispatch(ItemVsSupplierFun())
    dispatch(
      ItemVsSupplier({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ItemIDs: filters.itemName?.join(",") || "",
        ItemGrpIDs: filters.itemGroup?.join(",") || "",
        ItemSubGrpIDsIDs: filters.itemSubGroup?.join(",") || "",
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );

     setShowFilter(false);
  };

  const handleSubmit = () => {

    dispatch(ItemVsSupplierFun())
  
    dispatch(
      ItemVsSupplier({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ItemIDs: selectedItemName.join(","),
        ItemGrpIDs: selectedItemGroup.join(","),
        ItemSubGrpIDsIDs: selectedItemSubGroup.join(","),
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      })
    );
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ItemVsSupplierdata || ItemVsSupplierdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >

      <div className="d-lg-none text-end mb-2">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>



      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="align-items-end g-2"  >
          {/* DATE RANGE */}
          <Col lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour7 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8}`,
                  color: isdark === "light" ? iscolour?.Colour : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>

          {/* Book Name */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Item Name"
              data={itemNameList}
              selectedValue={itemNameSearch}
              setSelectedValue={setItemNameSearch}
              selectedId={selectedItemName}
              setSelectedId={setSelectedItemName}
              placeholder="Select Item Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Party Name */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Item Group"
              data={itemGroupList}
              selectedValue={itemGroupSearch}
              setSelectedValue={setItemGroupSearch}
              selectedId={selectedItemGroup}
              setSelectedId={setSelectedItemGroup}
              placeholder="Select Item Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Item Name */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Item Sub Group"
              data={itemSubGroupList}
              selectedValue={itemSubGroupSearch}
              setSelectedValue={setItemSubGroupSearch}
              selectedId={selectedItemSubGroup}
              setSelectedId={setSelectedItemSubGroup}
              placeholder="Select Item Sub Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Submit Button */}
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mt-3 hover-scale-btn ">
            <button
              onClick={handleSubmit}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour7
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour12
                    : iscolourDark?.Colour12,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
                padding: "12px"
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >

            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#fff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            <ColourFilterBox
              title="Item Name"
              items={itemNameList}
              search={search.itemName}
              setSearch={(val) => handleSearch("itemName", val)}
              selectedItems={filters.itemName}
              toggleItem={(item) => toggleItem("itemName", item)}
              selectAll={() => selectAll("itemName", itemNameList)}
            />

            <ColourFilterBox
              title="Item Group"
              items={itemGroupList}
              search={search.itemGroup}
              setSearch={(val) => handleSearch("itemGroup", val)}
              selectedItems={filters.itemGroup}
              toggleItem={(item) => toggleItem("itemGroup", item)}
              selectAll={() => selectAll("itemGroup", itemGroupList)}
            />

            <ColourFilterBox
              title="Item Sub Group"
              items={itemSubGroupList}
              search={search.itemSubGroup}
              setSearch={(val) => handleSearch("itemSubGroup", val)}
              selectedItems={filters.itemSubGroup}
              toggleItem={(item) => toggleItem("itemSubGroup", item)}
              selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
            />

            <button
              onClick={handleSubmit1}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour7
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour12
                    : iscolourDark?.Colour12,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
                padding: "12px"
              }}
            >
              Apply Filter
            </button>
          </div>

        </Offcanvas.Body>
      </Offcanvas>


      <Row>
        {/* TABLE   */}
        <Col lg={12}>
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              marginBottom: "20px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "20px",
            }}
          >
            {/* 🔹 HEADING */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MAX/MIN RATE
            </div>

            {/* 🔹 TABLE */}
            <ColourParentChild
              data={rows}
              columns={columns}
              parentKey="AcName"
            // childKey="MonthName"
            />
          </div>

          {/* 🔹 BUTTONS */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            {["ITEMWISE", "PARTYWISE"].map((btn) => (
              <button
                key={btn}
                onClick={() => setActiveTable(btn)}
                style={{
                  flex: 1,
                  height: "50px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontWeight: "600",
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour8
                    }`,
                  background:
                    activeTable === btn
                      ? isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour8
                      : isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour4,
                  color:
                    activeTable === btn
                      ? isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1
                      : isdark === "light"
                        ? iscolour?.Colour8
                        : "#fff",
                }}
              >
                {btn}
              </button>
            ))}
          </div>

          {/* 🔹 TABLE SWITCH */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              marginTop: "20px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {/* 🔹 HEADING */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              {activeTable}
            </div>

            {/* 🔹 TABLE */}
            <ColourTable
              data={activeTable === "ITEMWISE" ? TableChartRow : TableChartRow1}
              columns={
                activeTable === "ITEMWISE"
                  ? TableChartColumns
                  : TableChartColumns1
              }
            />
          </div>
        </Col>
      </Row>

      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
